/* Horizontal rail arrows — global, because section {% javascript %} is gated per
   section TYPE, and these rails live on the home page, the results page and the
   how-it-works page alike. Binds every [data-srail] on the page.

   The product page is deliberately NOT part of this: it keeps its own .rail__btn
   controls in each section head, driven by its own section JS. */
(function () {
  'use strict';

  var GAP_FALLBACK = 16;
  var EDGE = 4; /* px of slack — sub-pixel scroll positions never hit 0 or max exactly */

  function bind(root) {
    var track = root.querySelector('[data-srail-track]');
    if (!track || track.dataset.srailBound) return;
    track.dataset.srailBound = '1';

    var prev = root.querySelector('[data-srail-prev]');
    var next = root.querySelector('[data-srail-next]');

    /* Scroll by whole cards — as many as are actually on screen — so a click always
       lands the next card flush against the left edge rather than mid-card. */
    function stride() {
      var card = track.firstElementChild;
      var w = card ? card.getBoundingClientRect().width : track.clientWidth * 0.8;
      var cs = window.getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || GAP_FALLBACK;
      var per = Math.max(1, Math.floor(track.clientWidth / (w + gap)));
      return (w + gap) * per;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      root.classList.toggle('is-scrollable', max > EDGE * 2);
      if (prev) prev.disabled = track.scrollLeft <= EDGE;
      if (next) next.disabled = track.scrollLeft >= max - EDGE;
    }

    function nudge(dir) {
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: dir * stride(), behavior: still ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* Cards hold images that land after first paint and change scrollWidth, which
       decides whether the arrows show at all — so watch the track, don't guess. */
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(sync);
      ro.observe(track);
      if (track.firstElementChild) ro.observe(track.firstElementChild);
    }
    sync();
  }

  function init(scope) {
    var rails = (scope || document).querySelectorAll('[data-srail]');
    for (var i = 0; i < rails.length; i++) bind(rails[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  window.addEventListener('load', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
